<template>
  <p class="mb-8" data-testid="customer-address">
    This appointment will be booked for
    {{ current.account.data.supplyAddress?.formattedAddress }}
  </p>
  <SoTimeSlotPicker
    ref="time-slot-picker"
    v-model="selectedAppointmentSlot"
    :timeslots="appointmentTimes"
    label=" Please choose a date below and then select an available time slot."
    @update:model-value="updateAppointment($event)"
  />
  <SoCheckbox
    v-if="isMeterExchange"
    ref="no-slots-work-checkbox"
    v-model="appointmentData.noSuitableAppointments"
    label="None of these appointment slots work for the customer"
    class="mt-4"
  />
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoTimeSlotPicker from "@/components/formControls/SoTimeSlotPicker.vue"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { ITimeSlot } from "@/models/imbpAvailableSlots/imbpAvailableSlots.types"
  import { JobType } from "@/flows/useCases/imbpBooking/imbpBookingFlowHelper"
  import { AppointmentType } from "@/constants/imbp"

  export default defineComponent({
    components: {
      SoTimeSlotPicker,
      SoCheckbox,
    },
    props: {
      modelValue: {
        type: Object,
        default: () => ({}),
      },
      appointmentSlots: {
        type: Object as PropType<ITimeSlot[]>,
        required: true,
      },
      jobType: {
        type: Object as PropType<JobType>,
        default: () => ({}),
      },
    },
    emits: ["update:model-value"],
    data() {
      return {
        current: useCurrentAccountStore(),
        selectedAppointmentSlot: null,
        appointmentData: {
          appointmentSlot: {} as ITimeSlot,
          noSuitableAppointments: false,
        },
      }
    },
    computed: {
      appointmentTimes() {
        return this.appointmentSlots.map((appointment) => {
          return appointment.dateTimeRange
        })
      },
      isMeterExchange() {
        return (
          this.jobType?.selectedAppointmentType ===
          AppointmentType.METER_EXCHANGE
        )
      },
    },
    watch: {
      appointmentData: {
        handler() {
          this.$emit("update:model-value", this.appointmentData)
        },
        deep: true,
      },
    },
    methods: {
      updateAppointment(dateTimeRange) {
        if (!dateTimeRange) return
        const appointmentSelected = this.appointmentSlots.find(
          (appointment) =>
            appointment.dateTimeRange[0].getTime() ===
              dateTimeRange[0].getTime() &&
            appointment.dateTimeRange[1].getTime() ===
              dateTimeRange[1].getTime(),
        )
        if (appointmentSelected) {
          this.appointmentData.appointmentSlot = appointmentSelected
        }
      },
    },
  })
</script>
